import { ProductSupplierModelType } from '@teinor/erp/types/company/product/productSupplier'
import { useParams } from 'react-router'
import ModalCreateEdit from '../../../../../../baseComponents/ModalsLayouts/ModalCreateEdit'
import { ModalEditComponentProps } from '../../../../../../baseComponents/ModalsLayouts/types'
import { permissionCheck } from '../../../../../../baseComponents/PermissionChecker/function'
import { FormRender } from '../../../../../../forms/FormRenderer/types'
import { TwinDictionary } from '../../../../../../utils/globals/dictionary'
import useTwinTranslation from '../../../../../../utils/hooks/useTwinTranslation'
import { getISOCurrencyMain } from '../../../../../../utils/reducers/getters'
import { useBasicData } from '../../../../../../utils/hooks/useBasicData'
import { valueOrDefaultValue } from '../../../../../../utils/globals/valueOrDefaultValue'

interface ModalEditProductSupplierProps extends ModalEditComponentProps { }

const ModalEditProductSupplier: React.FC<ModalEditProductSupplierProps> = ({ userPermissions, allRowData, ...rest }) => {
    const { id } = useParams()
    const { basicData } = useBasicData({ params: { SupplierId: allRowData?.SupplierId, ProductId: id }, url: '/api/app/product/productSupplier/getProductSupplierInstance' })
    const { t } = useTwinTranslation()
    const itemsTypeDiscount: TwinDictionary = { 0: { name: t('percentage', 'Porcentaje') }, 1: { name: t('amountTotal', 'Importe total') }, 2: { name: t('amountUnit', 'Importe por unidad') } }
    const mainCurrency = getISOCurrencyMain()
    const fields: FormRender<ProductSupplierModelType> = [
        {
            cols: 2,
            elements: [
                {
                    name: 'SupplierId',
                    label: t('supplier', 'Proveedor'),
                    component: 'CustomSelectWithSearchBar',
                    items: basicData?.Supplier ? { [basicData?.SupplierId]: basicData?.Supplier } : {},
                    value: allRowData?.SupplierId || '',
                    required: true,
                    readOnly: true
                },
                {
                    name: 'supplier_reference',
                    label: t('supplierReference', 'Referencia del proveedor'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                },
                {
                    name: 'delivery_time',
                    label: t('deliveryTime', 'Tiempo de entrega'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                },
                {
                    name: 'last_price',
                    label: t('lastPrice', 'Último precio'),
                    component: 'InputCurrencyStateFull',
                    defaultValue: { price: allRowData?.last_price, CurrencyId: allRowData?.CurrencyId || mainCurrency },
                    nameExtended: { price: 'last_price', CurrencyId: 'CurrencyId' }
                },
                {
                    name: 'last_discount',
                    label: t('lastDiscount', 'Último descuento'),
                    component: 'InputWithLabelMargin',
                },
                {
                    name: 'last_type_discount',
                    label: t('typeDiscount', 'Tipo descuento'),
                    component: 'CustomSelect',
                    items: itemsTypeDiscount,
                },
                {
                    name: 'last_buy_date',
                    label: t('lastBuyDate', 'Última fecha de compra'),
                    component: 'InputCalendarStateFull',
                    readOnly: true
                },
                {
                    name: 'default_supplier',
                    label: t('defaultSupplier', 'Proveedor por defecto'),
                    component: 'CheckboxMargin',
                },
                {
                    name: 'ProductId',
                    component: 'InputHidden',
                    value: id,
                }
            ],
        },
    ]
    if (allRowData && userPermissions) {
        const parsedFields = valueOrDefaultValue(fields, userPermissions, basicData || {})
        return (<ModalCreateEdit fields={parsedFields} url={'/api/app/product/productSupplier/updateProductSupplier'} translations={{ title: t('editSupplier', 'Editar proveedor'), button: t('save', 'Guardar') }} haveButtonPermissions={permissionCheck(userPermissions, 'update')} {...rest} />)
    }

    return (null)
}


export default ModalEditProductSupplier;